var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketReservedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ticket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 13.4062C19.5 12.0263 20.62 10.9062 22 10.9062V9.90625C22 5.90625 21 4.90625 17 4.90625H7C3 4.90625 2 5.90625 2 9.90625V10.4062C3.38 10.4062 4.5 11.5263 4.5 12.9062C4.5 14.2862 3.38 15.4062 2 15.4062V15.9062C2 19.9062 3 20.9062 7 20.9062H17C21 20.9062 22 19.9062 22 15.9062C20.62 15.9062 19.5 14.7862 19.5 13.4062Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 4.90625L10 20.9063",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketReservedIcon);
export default __webpack_public_path__ + "static/media/ticket-reserved-icon.761038993ac9390b6d2da216f42ade60.svg";
export { ForwardRef as ReactComponent };